export default {
  methods: {
    $_checkProperties(obj) {
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(obj)) {
        if (value !== '' && value != null) {
          return true;
        }
      }

      return false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/checkProperties.js